import React from 'react';
import { type EmendaHistoricoDTO } from '../services/emendaService';
import { emendaHistoryTone, emendaHistoryLabel, fDateTime } from '../utils/emendaFormatters';

interface Props {
  items: EmendaHistoricoDTO[];
  loading: boolean;
}

const EmendaHistoricoTimeline: React.FC<Props> = ({ items, loading }) => (
  <section className="rounded-3xl border border-line bg-surface p-6 shadow-sm">
    <div className="flex items-center justify-between gap-3 border-b border-line pb-4">
      <div>
        <h2 className="text-lg font-semibold text-fg">Linha do tempo</h2>
        <p className="mt-1 text-sm text-fg-muted">Atualizações mais recentes do fluxo da emenda.</p>
      </div>
      <span className="rounded-full border border-line bg-surface-muted px-3 py-1 text-xs font-semibold text-fg-muted">{items.length} eventos</span>
    </div>
    {loading ? (
      <p className="mt-5 text-sm text-fg-muted">Carregando histórico...</p>
    ) : items.length === 0 ? (
      <p className="mt-5 text-sm text-fg-muted">Nenhum histórico registrado.</p>
    ) : (
      <div className="relative mt-6">
        <div className="absolute bottom-0 left-[11px] top-0 w-px bg-gradient-to-b from-sky-200 via-slate-200 to-slate-100" />
        <div className="space-y-5">
          {items.map((item) => {
            const tone = emendaHistoryTone(item.acao);
            return (
              <div key={item.id} className="relative pl-9">
                <div className={`absolute left-0 top-5 h-6 w-6 rounded-full border-4 border-white shadow-lg ${tone.dot}`} />
                <div className="rounded-2xl border border-line bg-surface p-4 shadow-sm">
                  <div className="flex flex-wrap items-start justify-between gap-3">
                    <div className="space-y-2">
                      <span className={`inline-flex rounded-full border px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] ${tone.badge}`}>{emendaHistoryLabel(item.acao)}</span>
                      <p className="text-sm font-semibold text-fg">{item.statusNovo || item.statusAnterior || 'Atualização de status'}</p>
                    </div>
                    <p className="text-xs font-medium text-fg-muted">{fDateTime(item.dataHora)}</p>
                  </div>
                  {item.observacao && <p className="mt-3 rounded-xl bg-surface-muted px-3 py-2 text-sm leading-6 text-fg-muted">{item.observacao}</p>}
                  {item.acao === 'RECEBIDO_CAMARA' && (item.leiNumero || item.departamento) && (
                    <div className="mt-2 rounded-xl border border-blue-100 bg-info-soft px-3 py-2 space-y-1">
                      {item.leiNumero && <p className="text-xs text-info-fg"><span className="font-semibold">Lei:</span> {item.leiNumero}</p>}
                      {item.leiDescricao && <p className="text-xs text-info-fg">{item.leiDescricao}</p>}
                      {item.departamento && <p className="text-xs text-info-fg"><span className="font-semibold">Departamento:</span> {item.departamento}</p>}
                      {item.dataRegistradaHistorico && <p className="text-xs text-info-fg"><span className="font-semibold">Data registrada:</span> {new Date(item.dataRegistradaHistorico).toLocaleDateString('pt-BR')}</p>}
                    </div>
                  )}
                  <div className="mt-3 text-xs text-fg-muted">{item.usuario ? `Por ${item.usuario}` : 'Atualização do sistema'}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    )}
  </section>
);

export default EmendaHistoricoTimeline;
